{
  "Nav": {
    "MakePayments": "Make Payments",
    "SendMoney": "Send Money",
    "SignUp": "Sign up",
    "LogIn": "Log in"
  },
  "Hero": {
    "Chip": "The AI Bill-Pay Platform",
    "TitleLine1": "Cross-border Property Bills,",
    "TitleLine2Lead": "Paid ",
    "TitleLine2Accent": "Intelligently.",
    "Subtitle": "Automated invoicing + household payments for property managers, vendors, and the clients they serve —",
    "SubtitleBold": "all in one place.",
    "PrimaryCta": "Sign Up Today",
    "SecondaryCta": "Schedule Demo"
  },
  "Diagram": {
    "PropertyManagers": "Property Managers",
    "HOAs": "HOAs",
    "Vendors": "Vendors",
    "Contractors": "Contractors",
    "AI": "AI",
    "TimeSaved": "Time saved",
    "Homeowners": "Homeowners"
  },
  "Banner": {
    "Text": "Need to send money to friends and family?",
    "Link": "Try Sendola Pay"
  },
  "Tabs": {
    "WhoWeServe": "Who We Serve?",
    "WhoWeCanPay": "Who We can Pay?",
    "ConciergeService": "Concierge Service",
    "PricingSavings": "Pricing + Savings",
    "FrequentQA": "Frequent Q&A's"
  },
  "EverythingYouNeed": {
    "Title": "Everything You Need to Know"
  },
  "WhoWeServe": {
    "Title": "Made for Modern Property Ownership",
    "Card1Title": "American Homeowners",
    "Card1Desc": "who with property investments in luxury communities, need to pay local property managers, staff and vendors.",
    "Card2Title": "Vendors and Service providers",
    "Card2Desc": "who require reliable global transactions on-time payment in Mexico.",
    "Card3Title": "Property Management Firms",
    "Card3Desc": "handling high-value monthly disbursements for maintenance, utilities, and household staff.",
    "Card4Title": "Family offices and Financial Advisors",
    "Card4Desc": "seeking to consolidate and automate their international property-related payments."
  },
  "WhoWeCanPay": {
    "Title": "Communities Using Sendola Today",
    "Desc": "Trusted by exclusive communities and property owners in the world's most sought-after destinations. We're expanding into new markets every month.",
    "SupportTitle": "We support payments to",
    "CounterNumber": "40+",
    "CounterLabel": "countries",
    "SupportDesc": "And continuously expanding into new destinations and communities worldwide.",
    "BottomText": "If your property is located elsewhere and you'd like to use Sendola, let us know, we may already support your region or can explore adding it next."
  },
  "WhoWePay": {
    "Title": "Who We Pay?",
    "Col1Title": "HOAs & Residential Communities",
    "Col1Desc": "Pay any HOA or residential community fees, including:",
    "Col1Item1": "Monthly dues & maintenance fees",
    "Col1Item2": "Property expenses",
    "Col2Title": "Utilities & Energy Providers",
    "Col2Desc": "Payments for electricity, gas and related services:",
    "Col2Item1": "CFE",
    "Col2Item2": "Engie Maxigas",
    "Col2Item3": "Naturgy",
    "Col2Item4": "Monthly dues & maintenance fees",
    "Col3Title": "Other Services",
    "Col3Desc": "Handle all water-related payments across multiple regions:",
    "Col3Item1": "AGUAKAN - Cancun",
    "Col3Item2": "SACMEX (Mexico City)",
    "Col3Item3": "SIAPA (Guadalajara)",
    "Col3Item4": "SEAPAL (Puerto Vallarta)",
    "Col3Item5": "Other local providers",
    "Col4Title": "Internet, TV & Telecommunications",
    "Col4Desc": "Pay for connectivity, streaming and cable services:",
    "Col4Item1": "SKY",
    "Col4Item2": "Totalplay",
    "Col4Item3": "Megacable",
    "Col4Item4": "Izzi Telecom",
    "Col4Item5": "DISH",
    "Col5Title": "Entertainment & Digital Services",
    "Col5Desc": "Manage all recurring digital and household subscriptions:",
    "Col5Item1": "Netflix",
    "Col5Item2": "VIX Premium",
    "Col5Item3": "Paramount+",
    "Col5Item4": "Prime Video",
    "Col5Item5": "and more"
  },
  "Concierge": {
    "Title": "Concierge Service",
    "CardTitle1": "Global Support,",
    "CardTitle2": "On Demand",
    "CardDesc": "Receive dedicated support from financial experts committed to your global success.",
    "SaferTitle": "A safer way to make payments internationally",
    "SaferDesc": "Sendola Pay operates under a robust regulatory framework to ensure compliance with local laws and international AML best practices."
  },
  "Pricing": {
    "CardLabel": "ALL-IN FX PRICING",
    "CardHeadline": "Clear, Locked and Fully Disclosed Before Execution",
    "CardFooter": "Pricing reflects real market access costs and liquidity conditions, no hidden spreads.",
    "Title": "Pricing Transparency",
    "DescStart": "Every transaction is ",
    "DescBold": "quoted upfront with a final exchange rate.",
    "DescEnd": " What you approve is exactly what settles.",
    "Tag1": "Upfront FX Rate",
    "Tag2": "No Post-Trade Fees",
    "Tag3": "Predictable Settlement"
  },
  "LevelUp": {
    "TitleLine1": "Ready to Level Up your",
    "TitleLine2": "Payments Experience",
    "Cta": "Sign Up Today"
  },
  "ClientsSay": {
    "Title": "What Our Clients Say",
    "Client1Name": "WORK WORLD JOBS",
    "Client1Quote": "Sendola is a secure and reliable solution for international payments. Transactions are fast and smooth, and their professional support makes them a trusted partner for our global needs.",
    "Client1Stars": "4",
    "Client2Name": "MARAVILLA SFC LLC",
    "Client2Quote": "Fast responses, an easy process, and a smooth overall experience. The transaction was completed efficiently and with great support.",
    "Client2Stars": "5",
    "Client3Name": "EL DORADO GOLF & BEACH CLUB",
    "Client3Quote": "Sendola's customer service stands out. The team is professional, knowledgeable, and genuinely focused on solving issues quickly.",
    "Client3Stars": "5",
    "Client4Name": "COSTA BRAVA HOA",
    "Client4Quote": "Sendola is a secure and reliable solution for international payments. Transactions are fast and smooth, and their professional support makes them a trusted partner for our global needs.",
    "Client4Stars": "4"
  },
  "Testimonial": {
    "Quote": "\u201CAs a property professional, Sendola has transformed how we handle international payments, saving us countless hours and reducing costs significantly\u201D",
    "Author": "-Property Management Director, Los Cabos-"
  },
  "Footer": {
    "Solutions": "Solutions",
    "MakePayments": "Make Payments - For Businesses",
    "SendMoney": "Send Money - For Individuals",
    "Pricing": "Pricing",
    "WhoWePay": "Who We Pay",
    "UseCases": "Use Cases",
    "ConciergeService": "Concierge Service",
    "Faqs": "FAQ's",
    "LegalInformation": "Legal Information"
  },
  "Faq": {
    "Title": "Frequently Asked Questions",
    "Cta": "Schedule Demo",
    "Q1": "What is Sendola?",
    "A1": "Sendola is a company that facilitates global payments from the United States in a simple and secure way. Sendola is registered in the United States, with offices in Scottsdale, Arizona, and is not a banking institution.",
    "Q2": "In which countries can I make payments?",
    "A2": "With Sendola, you can make payments to Mexico, Canada, Central America, South America, Europe, Asia, and Oceania. If you need to confirm whether a specific country is available, our team can help you.",
    "Q3": "How long does a transaction take to complete?",
    "A3": "Payments received on business days before 2:00 p.m. (CT) begin processing the same day. Deposits received after that time, as well as on weekends or holidays, are processed the next business day.",
    "Q4": "From which locations am I allowed to make payments?",
    "A4": "Money transfers with Sendola can be made from any state in the United States.",
    "Q5": "What documents can I use for identity verification during registration?",
    "A5": "To complete your registration with Sendola, you will need a valid passport.",
    "Q6": "What do I need to register to make payments on behalf of my company?",
    "A6": "To make payments on behalf of your company, we request basic information about the company and its legal representatives. Specific documents will be requested directly during the registration process or through our support team, as applicable.",
    "Q7": "How will I be notified that I've completed my registration and can make payments?",
    "A7": "Once you complete the validation process, you will receive a notification confirming your registration status. You will receive an email informing you that your account has been approved. Upon logging into the platform, you will see a confirmation message indicating that you can now make your money transfers.",
    "Q8": "What payment methods can I use?",
    "A8": "Currently, money transfers with Sendola are made via bank wire transfer from a USD account.",
    "Q9": "What information do I need to register a beneficiary?",
    "A9": "To register a beneficiary in Mexico, you will need to provide basic information that allows us to verify their identity and bank account, such as: beneficiary name, beneficiary address, official identification document, bank account details (CLABE or bank account statement), phone number and contact email. If the beneficiary is a company, additional information may be required.",
    "Q10": "For Mexico, which banks can I send payments to?",
    "A10": "Sendola can make payments to most banks that are part of the Mexican Financial System.",
    "Q11": "How can I check my transaction receipt?",
    "A11": "Once your transaction has been completed, you will receive a receipt via email and you can also download it directly from the platform.",
    "Q12": "How can I contact Sendola's Customer Service?",
    "A12": "At Sendola, we are available to help you with any questions or inquiries. You can reach us through email at concierge@sendola.com or on our Contact page, where you can call us directly or book a meeting with our team.",
    "Q13": "Does Sendola allow domestic transfers within the US?",
    "A13": "No. Currently, Sendola only processes international payments to the previously listed destinations, including bill payments and other expenses abroad.",
    "Q14": "Once I've made my wire transfer, how long does it take to be reflected?",
    "A14": "Once you complete the registration process, transactions may take up to 36 business hours to complete, depending on the time we receive your deposit and the validation processes.",
    "Q15": "Is the exchange rate fixed?",
    "A15": "The exchange rate may vary due to foreign exchange market fluctuations. Although Sendola strives to offer a stable exchange rate throughout the day, in some cases there may be movements that require an updated quote. When this happens, we will inform you and offer you an updated exchange rate."
  },
  "Legal": {
    "Title": "Legal Information",
    "Address": "Sendola Corp. 6710 E. Camelback Rd, Scottsdale, AZ 85253, U.S.A.",
    "Bullet1": "Terms of Service",
    "Bullet2": "Privacy Policy",
    "Bullet3": "Data & Retention Policy",
    "Bullet4": "Data Security Policy",
    "Bullet5": "Disclosure and Electronic Communications Agreement",
    "Bullet6": "USA Patriot Act Notice",
    "Bullet7": "Product Schedule — Property Bill-Payment Services",
    "SEOTitle": "Legal Information | Sendola — For Homeowners"
  },
  "Contact": {
    "HeadingTitle": "Contact Our Team",
    "HeadingSubtitle": "Let's talk about how Sendola can simplify your property payments",
    "Questions": "Whether you have questions, want to see a demo, or need help getting started, our team is here for you.",
    "ContactCards": {
      "Card1": {
        "Title": "Call us",
        "Text": "Prefer to speak directly?\nWe're just a call away.",
        "Button": "+1 (520) 342-0520"
      },
      "Card2": {
        "Title": "Book a meeting",
        "Text": "Choose a time that works best for you",
        "Button": "Schedule a call"
      }
    },
    "WeAreHere": "We're here for you",
    "Available": "Available Monday to Friday, 9am - 6pm PST",
    "SEOTitle": "Contact Us | Sendola — For Homeowners"
  },
  "ComingSoon": {
    "Title": "Coming Soon",
    "Body": "We're putting the finishing touches on this feature. In the meantime, our team can help you get started with pre-registration or our concierge service.",
    "Cta": "Contact Our Team"
  },
  "SEO": {
    "Title": "Sendola — Property Payment Management for US Homeowners in Mexico",
    "Description": "Manage HOA fees, utilities, vendor invoices and recurring services for your property in Mexico. All in one secure place."
  }
}
